import { Response } from '../../../../generic/v2/response/response';
import { ConversationRequestName } from '../../../conversation-request-name';

export abstract class ConversationResponse<T> extends Response<ConversationRequestName, T> {}
